import { Axios } from "@workspace/common";
import {
  BASE_JOB_PORTAL,
  BASE_PARSE_RESUME,
  BASE_CANDIDATES,
  DOCUMENT_CONVERSION,
  BASE_LLM_INTERVIEW,
} from "./url_helper";
import {
  JOB_URL,
  COMMON_URL,
  CANDIDATE_URL,
  AI_URL,
} from "@workspace/common/src/config";

const { APIClient } = Axios;

const api = new APIClient();

/* Job Portal APIs */
//GET all jobs with pagination, search and filter
export const getJobList = (page, searchFilter) =>
  api.create(`${JOB_URL}${BASE_JOB_PORTAL}/jobs?page=${page}`, searchFilter);

//GET job by jobId
export const getJob = (jobId) =>
  api.get(`${JOB_URL}${BASE_JOB_PORTAL}/jobs/${jobId}`);

//GET work locations
export const getWorkLocations = (countryLocation) =>
  api.create(`${JOB_URL}${BASE_JOB_PORTAL}/jobs/locations`, countryLocation);

/* Job Portal Job Application APIs */
//POST candidate resume
export const parseResume = (formData) =>
  api.create(`${COMMON_URL}${BASE_PARSE_RESUME}/job-portal/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

//POST candidate job application
export const postJobApplication = (formData, jobId) =>
  api.create(`${JOB_URL}${BASE_JOB_PORTAL}/jobs/${jobId}/apply`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

/* Pulse Job Application APIs */
//GET all job applications with pagination
export const getJobApplicationList = (params) =>
  api.create(`${JOB_URL}${BASE_JOB_PORTAL}/applications`, params);

//GET candidate resume by id
export const getJobApplicationResumeById = (id) =>
  api.get(`${JOB_URL}${BASE_JOB_PORTAL}/downloadResume/${id}`);

//Convert ms to pdf
export const convertMsDocToPdf = (data) =>
  api.create(`${COMMON_URL}/${DOCUMENT_CONVERSION}/convert/ms-pdf`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

//CUSTOMVIEW - POST job application custom view
export const createJobAppCustomView = (data) =>
  api.create(
    `${JOB_URL}${BASE_JOB_PORTAL}/applications/save/customfields`,
    data
  );

//CUSTOMVIEW - GET all job application custom views
export const getJobAppCustomView = () =>
  api.get(`${JOB_URL}${BASE_JOB_PORTAL}/applications/customView/all`);

//CUSTOMVIEW - GET job application custom view by id
export const getJobAppCustomViewById = (id) =>
  api.get(`${JOB_URL}${BASE_JOB_PORTAL}/applications/customView/${id}`);

//CUSTOMVIEW - DELETE job application custom view by id
export const deleteJobAppCustomView = (id) =>
  api.delete(
    `${JOB_URL}${BASE_JOB_PORTAL}/applications/customView/delete/${id}`
  );

//CUSTOMVIEW - SELECT job application custom view by id
export const selectJobAppCustomViewById = (id) =>
  api.put(`${JOB_URL}${BASE_JOB_PORTAL}/applications/customView/update/${id}`);

//CUSTOMVIEW - UNSELECT job application custom view
export const unselectJobAppCustomView = () =>
  api.put(`${JOB_URL}${BASE_JOB_PORTAL}/applications/customView/unselect-all`);

//CUSTOMVIEW - EDIT job application custom view by id
export const editJobAppCustomViewById = (id, data) =>
  api.put(
    `${JOB_URL}${BASE_JOB_PORTAL}/applications/customView/edit/${id}`,
    data
  );

//Update status of job application
export const updateJobApplicationStatusById = (id, status) =>
  api.put(
    `${JOB_URL}${BASE_JOB_PORTAL}/applications/${id}/status?status=${status}`
  );

//POST job application rejection by id
export const rejectJobApplicationById = (id, rejectionReason) =>
  api.create(
    `${JOB_URL}${BASE_JOB_PORTAL}/applications/reject-candidate/${id}`,
    rejectionReason
  );

//GET candidate id by email from candidate service
export const getCandidateIdByEmail = (email) =>
  api.get(`${CANDIDATE_URL}${BASE_CANDIDATES}/candidateId?email=${email}`);

export const getJobApplicationVideoById = (id) =>
  api.get(`${JOB_URL}${BASE_JOB_PORTAL}/jobs/video/${id}`, {
    responseType: "blob",
  });

// Interview Backend helper
export const startInterview = (data, config = {}) =>
  api.create(`${AI_URL}${BASE_LLM_INTERVIEW}/start-interview`, data, config);

export const interview = (data, signal={}) =>
  api.create(`${AI_URL}${BASE_LLM_INTERVIEW}/interview`, data, {
    headers: { "Content-Type": "multipart/form-data" },
    ...signal,
  });

export const getToken = (data) =>
  api.create(`${AI_URL}${BASE_LLM_INTERVIEW}/token`, data);

export const transcribeAudio = (data, signal={}) =>
  api.create(`${AI_URL}${BASE_LLM_INTERVIEW}/transcribe-audio`, data, {
    headers: { "Content-Type": "multipart/form-data" },
    ...signal,
  });

//GET job by jobId
export const getJobNofilter = (jobId) =>
  api.get(`${JOB_URL}${BASE_JOB_PORTAL}/jobs/${jobId}/nofilter`);
